<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Collection</p>
      <b-button @click="deleteCollection" type="is-danger" icon-right="delete">
        Delete Collection</b-button
      >
    </header>
    <section class="modal-card-body">
      <b-notification
        @close="resetErrors"
        :active="localCollectionErrors != null"
        type="is-danger"
        has-icon
        aria-close-label="Close notification"
        role="alert"
      >
        {{ localCollectionErrors }}
      </b-notification>

      <b-field label="Collection name">
        <b-input
          maxlength="50"
          placeholder="Naruto"
          v-model="localCollection.name"
        ></b-input>
      </b-field>

      <b-field>
        <template slot="label">
          Visibility
          <b-tooltip
            position="is-right"
            type="is-dark"
            multilined
            size="is-small"
            label="Change visiblity to public so that everyone can enjoy your collection!"
          >
            <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
          </b-tooltip>
        </template>
        <b-switch
          v-model="localCollection.hidden"
          passive-type="is-warning"
          type="is-success"
          :true-value="false"
          :false-value="true"
        >
          <span v-if="!localCollection.hidden">
            <b-icon size="" type="" icon="earth"></b-icon>
            Public
            <span class="is-italic">(Everyone can view this Collection)</span>
          </span>
          <span v-else>
            <b-icon size="" type="" icon="lock"></b-icon>
            Private
            <span class="is-italic">(Only you can view this Collection)</span></span
          >
        </b-switch>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="edit" type="is-success" icon-pack="mdi" icon-right="check">
          Update
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>
    </footer>

    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['collection'],
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    }),
    visibilityText () {
      if (this.localCollection.hidden) return 'hidden'
      else return 'visible'
    }
  },
  data () {
    return {
      localCollection: {
        hidden: null,
        name: null
      },
      isLoading: false,
      localCollectionErrors: null
    }
  },
  methods: {
    edit () {
      if (
        this.localCollection.hidden.toString() !==
        this.collection.attributes.hidden.toString()
      ) {
        let visibilityMessage =
          this.localCollection.hidden === 'true'
            ? "Content won't be <b>accessible</b> for other cosplayers !"
            : 'Content will become <b>accessible</b> for any cosplayer.'
        this.$buefy.dialog.confirm({
          title: 'Updating collection',
          message: `Are you sure you want to update <b>${this.localCollection.name}</b>?<br>${visibilityMessage}`,
          confirmText: 'Update',
          type: 'is-primary',
          hasIcon: true,
          onConfirm: () => {
            this.editProcedure()
          }
        })
      } else {
        this.editProcedure()
      }
    },
    editProcedure () {
      this.isLoading = true
      this.$store
        .dispatch('users/collections/update', {
          user: this.currentUser.attributes.username,
          collection: this.collection.id,
          payload: this.localCollection
        })
        .then((resp) => {
          this.isLoading = false
          this.$emit('collectionEdited', resp.data.data)
          this.$parent.close()
        })
        .catch((error) => {
          this.isLoading = false
          console.log(error)
          this.localCollectionErrors = error
        })
    },
    deleteCollection () {
      this.$buefy.dialog.confirm({
        title: 'Deleting collection',
        message: `Are you sure you want to delete <b>${this.collection.attributes.name}</b>? This action cannot be undone.`,
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.isLoading = true
          this.$store
            .dispatch('users/collections/destroy', {
              user: this.currentUser.attributes.username,
              collection: this.collection.id
            })
            .then((resp) => {
              this.isLoading = false
              this.$emit('collectionRemoved', resp.data.data)
              this.$parent.close()
              this.$buefy.toast.open('Collection deleted!')
            })
            .catch((_) => {
              this.isLoading = false
            })
        }
      })
    },
    resetErrors () {
      this.localCollectionErrors = null
    }
  },
  created () {
    this.localCollection.hidden = this.collection.attributes.hidden
    this.localCollection.name = this.collection.attributes.name
  }
}
</script>
